module.exports = __webpack_public_path__ + "static/media/jefferson.98485f74.png";